var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangleVerticalHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 64C192 28.65 220.7 0 256 0H512C547.3 0 576 28.65 576 64V448C576 483.3 547.3 512 512 512H256C220.7 512 192 483.3 192 448V64zM224 64V448C224 465.7 238.3 480 256 480H512C529.7 480 544 465.7 544 448V64C544 46.33 529.7 32 512 32H256C238.3 32 224 46.33 224 64zM96 64C96 55.16 103.2 48 112 48C120.8 48 128 55.16 128 64V448C128 456.8 120.8 464 112 464C103.2 464 96 456.8 96 448V64zM0 112C0 103.2 7.164 96 16 96C24.84 96 32 103.2 32 112V400C32 408.8 24.84 416 16 416C7.164 416 0 408.8 0 400V112z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleVerticalHistory);
export default __webpack_public_path__ + "static/media/rectangle-vertical-history.0e3be914195210ac09289d2545c76d9e.svg";
export { ForwardRef as ReactComponent };